import { assign } from 'lodash';

// import directions
import { DIRECTION } from './../constants';

// defalt animation settings
const DEFAULT_SETTINGS = {
    direction: DIRECTION.FORWARD,
    distance: 100, // 100px
    duration: 0.5,
    delay: 0.3
};

// fade and slide animation config function
export const fadeInSlideX = _settings => {

    // generate final animation settings
    const settings = assign( {}, DEFAULT_SETTINGS, _settings );

	const position = DIRECTION.FORWARD === settings.direction ? settings.distance : -settings.distance;

	// variants
    const variants = {
        initial: {
            opacity: 0,
            x: position
        },
        enter: {
            opacity: 1,
            x: 0,
            transition: {
                duration: settings.duration,
				ease: [ .28, .57, .45, 1.22 ], // spring
				delay: settings.delay
            },
        },
        exit: {
            opacity: 0,
			x: -1 * position,
            transition: { duration: settings.duration, delay: settings.delay },
        },
    };

    return {
		variants,
        initial: 'initial',
		animate: 'enter',
		exit: 'exit',

    };
};
